module.exports = __webpack_public_path__ + "static/media/instagram-comments.26527ad7.jpg";